import theForksLogo from "../media/img/theforks-io-logo.jpg";
import '../css/pages/partial-pages.css';
function TheForks() {
  return(
    <div className="the-forks">
      <div className="blur-bg f-col center">
        <img src={theForksLogo}></img>
        <h3>Winnipeg's Open-Source GitHub Repository</h3>
        <div className="f-col">
          <a href="https://github.com/dave-sommerville/theForks.io" target="_blank" rel="noopener noreferrer">Visit the Repository</a>
          <a href="https://theforks.io" target="_blank" rel="noopener noreferrer">Learn more on the Website</a>
          <a href="https://www.linkedin.com/groups/14952094/" target="_blank" rel="noopener noreferrer">Join the LinkedIn Group</a>
        </div>
      </div>
    </div>
  );
}

export default TheForks;